import { render, staticRenderFns } from "./RightDisplayArea.vue?vue&type=template&id=657b53e4&scoped=true"
import script from "./RightDisplayArea.vue?vue&type=script&lang=js"
export * from "./RightDisplayArea.vue?vue&type=script&lang=js"
import style0 from "./RightDisplayArea.vue?vue&type=style&index=0&id=657b53e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b53e4",
  null
  
)

export default component.exports